<!-- Dashboard.tsx sticky feed header -->
<div class="sticky top-0 z-30 bg-card/80 backdrop-blur-md border-b border-border">
  <div class="flex">
    <button
      type="button"
      (click)="setTab('foryou')"
      class="flex-1 py-3.5 text-[15px] font-semibold text-center relative transition-colors"
      [ngClass]="activeTab === 'foryou' ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'">
      For You
      <div *ngIf="activeTab === 'foryou'" class="absolute bottom-0 left-1/2 -translate-x-1/2 w-14 h-[3px] rounded-full bg-ts-blue"></div>
    </button>
    <button
      type="button"
      (click)="setTab('following')"
      class="flex-1 py-3.5 text-[15px] font-semibold text-center relative transition-colors"
      [ngClass]="activeTab === 'following' ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'">
      Following
      <div *ngIf="activeTab === 'following'" class="absolute bottom-0 left-1/2 -translate-x-1/2 w-14 h-[3px] rounded-full bg-ts-blue"></div>
    </button>
  </div>
</div>
